"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
exports.isEventContentFeedDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "EventContentFeedDetails";
};
class EventPostProvider extends DataProvider_1.default {
    get fragments() {
        return {
            EventPost: () => `
        ... on EventPost {
          postId
          link
        }
      `,
            ContentFeedDetails: () => `
        ... on EventContentFeedDetails {
          link
        }
      `,
        };
    }
    find({ postIds }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("eventPostFind", { postIds }, this.getFragment("EventPost"));
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("eventPostUpdate", { data }, this.getFragment("EventPost"));
        });
    }
}
exports.EventPostProvider = EventPostProvider;
//# sourceMappingURL=EventPostProvider.js.map